import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { NgSelectComponent } from "@ng-select/ng-select";
import { Subscription } from "rxjs";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { ContactDetails } from "../contact-details";

@Component({
  selector: "skills-and-interests-contact-details",
  templateUrl: "skills-and-interests-contact-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SkillsAndInterestsContactDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SkillsAndInterestsContactDetails),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillsAndInterestsContactDetails
  extends ContactDetails
  implements ControlValueAccessor, OnDestroy
{
  dropdownFetch: Subscription;

  @Input() isEditMode: boolean = false;
  skillsAndInterestsOptions = [];
  languageOptions = [];
  showOther: boolean = false;
  @ViewChild("skillsList") skillsList: NgSelectComponent;
  skillsOpen: boolean = false;
  languageOpen: boolean = false;

  set value(value: any) {
    if (
      value.skillsAndInterests &&
      value.skillsAndInterests.includes("Other")
    ) {
      this.enableOther();
    }
    this.innerFormGroup.patchValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(
    protected formBuilder: FormBuilder,
    protected resourceManagementService: ResourceManagementService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(formBuilder);

    // create inner form
    this.innerFormGroup = this.formBuilder.group({
      skillsAndInterests: [null],
      languages: [null],
      other: [null],
    });

    this.dropdownFetch = this.resourceManagementService
      .getLookUpValues()
      .subscribe(
        this.onUpdateDropdown,
        console.error,
        this.onUpdateDropDownComplete
      );

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );

    this.subscriptions.push(
      this.innerFormGroup
        .get("skillsAndInterests")
        .valueChanges.subscribe((value) => {
          if (value && value.includes("Other")) {
            this.enableOther();
          } else {
            this.disableOther();
          }
        })
    );
  }

  enableOther() {
    this.innerFormGroup.get("other").setValidators([Validators.required]);
    this.innerFormGroup.get("other").updateValueAndValidity();
    this.showOther = true;
  }

  disableOther() {
    this.innerFormGroup.get("other").clearValidators();
    this.innerFormGroup.get("other").setValue(null);
    this.innerFormGroup.get("other").updateValueAndValidity();
    this.showOther = false;
  }

  onUpdateDropdown = (x) => {
    this.skillsAndInterestsOptions = x["SkillsAndInterests"].map((item) => ({
      display: item.description,
      value: item.description,
    }));

    this.languageOptions = x["Language"].map((item) => ({
      display: item.description,
      value: item.id,
    }));
  };

  onUpdateDropDownComplete = () => {
    this.changeDetectorRef.detectChanges();
  };

  valid(control: string) {
    return this.innerFormGroup.get(control).valid;
  }

  touched(control: string) {
    return this.innerFormGroup.get(control).touched;
  }

  validate(_: FormControl) {
    return this.innerFormGroup.valid
      ? null
      : { skillsAndInterests: { valid: false } };
  }

  ngOnDestroy() {
    if (this.dropdownFetch) {
      this.dropdownFetch.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-resources/contact-details/skills-and-interests/skills-and-interests-contact-details.ts